import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import { KuposInput } from '../common';
import ApiUrls from '../../services/apiUrls';
import CommonService from '../../services/commonService';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';

const initialState = {
  terminal_locations: [],
  company_locations: [],
  destination_locations: [],
  city_pair_locations: [],
}

const DefaultPage = (props) => {
  const { t, history } = props
  const [state, setState] = useState(initialState)
  // console.log({ props }, 'state', { state })

  useEffect(() => {
    window.scrollTo(0, 0);
    props.actions.apiCall({ url: ApiUrls.siteMap(), callback: res => onResponse(res) });
  }, [])

  // // http://stage.kupas.cl/en/bus-tickets/kenny-bus
  const onResponse = (res) => {
    console.log({ res })
    if (res && res.data && res.status === 200) {
      setState({
        ...state,
        terminal_locations: res.data.seo_term_details,
        company_locations: res.data.seo_op_details,
        destination_locations: res.data.seo_dest_details,
        city_pair_locations: res.data.seo_city_pair_details,
      })
    } else {
      // showFail case 
    }
  }


  const onTerminalInputChange = input => {
    // console.log({ input })
    let filteredTerminals = state.terminal_locations
      ? CommonService.copyObject(state.terminal_locations)
      : // ? CommonService.copyObject(this.props.siteMap.mySiteMap.seo_term_details.slice(0, 100))
      [];
    filteredTerminals = filteredTerminals.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    setState({ ...state, filteredTerminals, showFilteredTerminals: input && filteredTerminals ? true : false });
  };

  const onCompanyInputChange = input => {
    let filteredCompany = state.company_locations && CommonService.copyObject(
      state.company_locations,
      // this.props.siteMap.mySiteMap.seo_op_details.slice(0, 100),
    );
    filteredCompany = filteredCompany.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    setState({ ...state, filteredCompany, showFilteredCompany: input && filteredCompany ? true : false });
  };

  const onDestinationInputChange = input => {
    let filteredDestination = state.destination_locations && CommonService.copyObject(
      state.destination_locations,
      // this.props.siteMap.mySiteMap.seo_dest_details.slice(0, 100),
    );
    filteredDestination = filteredDestination.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    setState({ ...state, filteredDestination, showFilteredDestination: input && filteredDestination ? true : false });

  };

  const onCityInputChange = input => {
    let filteredCity = state.city_pair_locations && CommonService.copyObject(
      state.city_pair_locations,
      // this.props.siteMap.mySiteMap.seo_city_pair_details.slice(0, 100),
    );
    filteredCity = filteredCity.filter(val => {
      return (
        val[0]
          .split(',')[0]
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    });
    setState({ ...state, filteredCity, showFilteredCity: input && filteredCity ? true : false });
  };

  const getList = (val, key) => {
    //   // console.log('Some data --------', val);
    let empty = false;
    let label1, link1, link2;
    val.map((item, index) => {
      if (item == '') {
        empty = true;
      }
      if (!empty) {
        switch (index) {
          case 0:
            label1 = item;
            break;
          case 1:
            link1 = item;
            break;
          case 3:
            link2 = item;
            break;
        }
      }
    });
    return label1 ? (
      <li className="list-item font10" key={key}>
        <a href={`${window.location.origin}/${i18next.language === 'es' ? val[2] : val[1]}`}>{label1}</a>
      </li>
    ) : null;
  }

  const getPairedList = (val, key) => {
    //   // console.log('Item is ----------', val);
    let label1, label2, link1, link2;
    val.map((item, index) => {
      switch (index) {
        case 0:
          label1 = item;
          break;
        case 1:
          label2 = item;
          break;
        case 2:
          link1 = item;
          break;
        case 3:
          link2 = item;
          break;
      }
    });

    return (
      <li className="list-item font10" key={key}>
        <a href={`https://kupos.cl/${i18next.language === 'es' ? val[3] : val[2]}`}>
          {label1} to {label2}
        </a>
      </li>
    );
  }


  return (
    <div className="home-site-map">
      <div className="content-container">
        <div className="page-title font20">{t('HOME.SITEMAP')}</div>

        <div className="sitemam-grid-section">
          <div className="home-selection-input-box font13">
            <div className="primary-text upper-case-text">{t('HOME.TERMINALS')}</div>

            <KuposInput
              onChange={onTerminalInputChange}
              placeholder={t('HOME.SEARCH_TERMINAL')}
              icon="/images/icons/home/icon_search_primary.png"
              className={'kupos-sitemap-input'}
            />
            {state.terminal_locations ? (
              <div className="terminal-list">
                {state.filteredTerminals ? state.filteredTerminals.map((val, key) => getList(val, key))
                  : state.terminal_locations.map((val, key) => getList(val, key))}
              </div>
            ) : null}

          </div>

          <div className="home-selection-input-box font13">
            <div className="primary-text upper-case-text">{t('HOME.COMPANY_SITEMAP')}</div>

            <KuposInput
              onChange={onCompanyInputChange}
              placeholder={t('HOME.SEARCH_COMAPNY')}
              icon="/images/icons/home/icon_search_primary.png"
              className={'kupos-sitemap-input'}
            />
            {state.company_locations ? (
              <div className="terminal-list">
                {state.showFilteredCompany ? state.filteredCompany.map((val, key) => getList(val, key))
                  : state.company_locations.map((val, key) => getList(val, key))}
              </div>
            ) : null}
          </div>

          <div className="home-selection-input-box font13">
            <div className="primary-text upper-case-text">{t('HOME.DESTINATIONS')}</div>

            <KuposInput
              onChange={onDestinationInputChange}
              placeholder={t('HOME.SEARCH_DESTINATION')}
              icon="/images/icons/home/icon_search_primary.png"
              className={'kupos-sitemap-input'}
            />

            {state.destination_locations ? (
              <div className="terminal-list">
                {state.showFilteredDestination ? state.filteredDestination.map((val, key) => getList(val, key))
                  : state.destination_locations.map((val, key) => getList(val, key))}
              </div>
            ) : null}
          </div>

          <div className="home-selection-input-box font13">
            <div className="primary-text upper-case-text">{t('HOME.FREQUENT_ROUTES_UNIT')}</div>
            <KuposInput
              onChange={onCityInputChange}
              placeholder={t('HOME.SEARCH_FREQUENT_ROUTES')}
              icon="/images/icons/home/icon_search_primary.png"
              className={'kupos-sitemap-input'}
            />

            {state.city_pair_locations ? (
              <div className="terminal-list">
                {state.showFilteredCity ? state.filteredCity.map((val, key) => getList(val, key))
                  : state.city_pair_locations.map((val, key) => getList(val, key))}
              </div>
            ) : null}
          </div>
        </div>

        <div className="text-center font13 primary-text upper-case-text sitemap-our-pages-title">
          {t('HOME.OUR_PAGES')}
        </div>
        <div className="kupos-border sitemap-our-pages">
          {/* <div className="text-center font16 primary-text upper-case-text">
              {t('HOME.OUR_PAGES')}
            </div> */}

          <div className="sitemap-pages-grid-section font11">
            <div className="font10">
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/about`)}
              >
                {t('HOME.ABOUT_KUPOS')}
              </div>
              <div className="underline" onClick={() => history.push(`#`)}>
                {t('HOME.OUR_SERVICE')}
              </div>
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/our-investors`)}
              >
                {t('HOME.OUR_PARTNERS')}
              </div>
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/travel-agency`)}
              >
                {t('HOME.WORK_WITH_US')}
              </div>
            </div>

            <div className="font10">
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/press`)}
              >
                {t('HOME.PRESS')}
              </div>
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/contact`)}
              >
                {t('HOME.CONTACT_US')}{' '}
              </div>
              <div className="underline">
                <a href="https://kupos.zendesk.com/hc/es" target="_blank">
                  {t('HOME.FAQ')}
                </a>
              </div>
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/tnc`)}
              >
                {t('HOME.TNC')}{' '}
              </div>
            </div>

            <div className="font10">
              <div
                className="underline"
                onClick={() => history.push(`/${i18next.language}/pages/privacy-policy`)}
              >
                {t('HOME.PRIVACY_POLICY')}{' '}
              </div>
              {/* <div
                  className="underline"
                  onClick={() => history.push(`/${i18next.language}/pages/privacy-policy`)}
                >
                  {t('HOME.COOKIES_POLICY')}{' '}
                </div> */}


              <div className="underline">
                {props.home.metaData ? (
                  <a
                    href={props.home.metaData.social_media_urls.facebookUrl}
                    target="-blank"
                  >
                    {t('SOCIAL.FACEBOOK')}
                  </a>
                ) : null}
              </div>
              <div className="underline">
                {props.home.metaData ? (
                  <a href={props.home.metaData.social_media_urls.twitterUrl} target="_blank">
                    {t('SOCIAL.TWITTER')}
                  </a>
                ) : null}
              </div>
            </div>


            <div className="font10">
              <div className="underline">
                {props.home.metaData ? (
                  <a href={'https://www.instagram.com/pasajebus/'} target="_blank">
                    {t('SOCIAL.INSTAGRAM')}
                  </a>
                ) : null}
              </div>
              <div className="underline">
                {props.home.metaData ? (
                  <a href={props.home.metaData.social_media_urls.blogUrl} target="_blank">
                    {t('SOCIAL.BLOG_PASAJEBUS')}
                  </a>
                ) : null}
              </div>
              <div className="underline">
                {props.home.metaData ? (
                  <a href={props.home.metaData.social_media_urls.androidUrl} target="_blank">
                    {t('SOCIAL.PASAJEBUS_PLAYSTORE')}
                  </a>
                ) : null}
              </div>
              <div className="underline">
                {props.home.metaData ? (
                  <a href={props.home.metaData.social_media_urls.iosUrl} target="_blank">
                    {t('SOCIAL.PASAJEBUS_APPSTORE')}
                  </a>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
// }

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    siteMap: state.siteMap,
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/site-map/DefaultPage.js